"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useFileUpload = require("./useFileUpload");
Object.keys(_useFileUpload).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useFileUpload[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useFileUpload[key];
    }
  });
});